import {Col, Collapse, CollapseProps, Flex, Typography} from "antd";
import React, {useEffect, useState} from "react";
import {useTranslations} from "next-intl";
import {ThemeColors} from "@/src/entities/colors";
import {Faq} from "@/src/entities/faq";
import SanitazeHTML, {SanitazeOption} from "@/src/components/sanitazeHTML";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {ThemeService} from "@/src/services/theme";

type Props = {
    faqList: Faq[]
}

const FaqComponent = (props: Props) => {

    const localization = useTranslations('faq');
    const themeColors = ThemeService.getThemeColors()

    const retrieveCollapseItem = (): CollapseProps['items'] => {
        const sanitazeOptions: SanitazeOption = {
            ALLOWED_TAGS: ["a"],
            ALLOWED_ATTR:["target", "href", "class"]
        }
        return props.faqList.map((value, index) => {
            let title =
                <Flex gap={16} align={"center"}>
                    <QuestionCircleOutlined style={{fontSize: 16, color: themeColors.menuBarColor}} />
                    <Typography.Paragraph style={{margin: 0, color: themeColors.menuBarColor}}>{value.question}</Typography.Paragraph>
                </Flex>

            return {
                key: index,
                label: title,
                children: <SanitazeHTML html={value.answer} options={sanitazeOptions} />
            }
        })
    }

    return (
        <div style={{padding: 24}}>
            <Flex vertical gap={16} justify={"center"} align={"center"} style={{margin: "60px 0 40px 0", padding: "0 24px", textAlign: "center"}}>
                <Typography.Title level={2} className={"sectionTitle"}>{localization("title")}</Typography.Title>
                <Typography.Text  style={{fontSize: 16, color: "#444"}}>{localization("text")}</Typography.Text>
            </Flex>

            <Collapse items={retrieveCollapseItem()} accordion expandIconPosition={"end"} />
        </div>
    )
}

export default FaqComponent